import React from "react";
import "./pagetitle.scss";

const PageTitle = (props) => {
  const { title, style = {}, className = "", testid } = props;
  return (
    <h2
      style={{ ...(props.style || null) }}
      className={`${props.className || ""} mpng-report-header`}
      {...(testid ? { "data-testid": testid } : {})}
    >
      {title}
    </h2>
  );
};

export default PageTitle;
